import { render, staticRenderFns } from "./PeriodEdit.vue?vue&type=template&id=159eec0c"
import script from "@/controllers/custom/academic_period/period-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/academic_period/period-edit.js?vue&type=script&lang=js&external"
import style0 from "./PeriodEdit.vue?vue&type=style&index=0&id=159eec0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports